import { configureStore } from '@reduxjs/toolkit'

import authReducer from './authSlice.js'
import schedulerReducer from './schedulerSlice.js'
import messageReducer from './messageSlice.js'
import friendReducer from './friendSlice.js'
import groupReducer from './groupSlice.js'
import kazooEventReducer from './kazooEventSlice.js'
import venueReducer from './venueSlice.js'
import vendorReducer from './vendorSlice.js'
import plannerReducer from './plannerSlice.js'
import userReducer from './userSlice.js'
import notificationReducer from './notificationSlice.js'
import sidebarReducer from './sidebarSlice.js'
import proposalReducer from './proposalSlice.js'
import commonSlice from './commonSlice.js'
import reviewReducer from './reviewSlice.js'
import calendarReducer from './calendarSlice.js'
import packageReducer from './packageSlice.js'
import subscriptionReducer from './v2/subscriptionSlice.js'
import adminReducer from './adminSlice.js'
import guestListReducer from './guestListSlice.js'

export const store = configureStore({
	reducer: {
		// 'auth' slice manages user authentication and profile data
		auth: authReducer,

		// 'scheduler' slice manages timeline events (used in calendar/scheduler)
		scheduler: schedulerReducer,

		// 'message' slice manages messaging functionality (chat system)
		message: messageReducer,

		// 'friend' slice manages friend data and search functionality
		friend: friendReducer,

		// 'group' slice manages group-related data (e.g., wedding parties, planning groups)
		group: groupReducer,

		// 'kazooEvent' slice manages wedding-specific metadata
		kazooEvent: kazooEventReducer,

		venue: venueReducer,

		vendor: vendorReducer,

		planner: plannerReducer,

		user: userReducer,

		notification: notificationReducer,

		sidebar: sidebarReducer,

		proposal: proposalReducer,
		
		common: commonSlice,

		review: reviewReducer,
		calendar: calendarReducer,
		packages: packageReducer,
		subscription: subscriptionReducer,

		admin: adminReducer,

		guestList: guestListReducer,
	},

	// Middleware configuration
	middleware: (getDefaultMiddleware) =>
		getDefaultMiddleware({
			serializableCheck: false,
		}),
})

// 401 -> redirect user to login
// 403 -> forbiddened
// 409 -> duplicate error